import React, { Suspense } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';

import { LoginPage, HomePage, NotFoundPage ,UserPage, InternalUserPage } from './LazyLoading';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import Spinner from '../components/_common/Spinner';


const AppRouter = () => (
  <Router>
    <Suspense fallback={<Spinner />}>
      <Switch>
        <PublicRoute index path="/" component={LoginPage} exact={true} />
        <PublicRoute path="/admin/signin" component={LoginPage} exact={true} />
        <PrivateRoute path="/admin/home" component={HomePage} exact={true} />
        <PrivateRoute path="/admin/users" component={UserPage} exact={true} />
        <PrivateRoute path="/admin/internal-users" component={InternalUserPage} exact={true} />
        <Route component={NotFoundPage} />
      </Switch>
    </Suspense>
  </Router>
);

export default AppRouter;
